import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76bed79b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "0",
  rx: "4",
  ry: "4",
  width: "60",
  height: "30"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "80",
  y: "0",
  rx: "4",
  ry: "4",
  width: "100",
  height: "32"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "36",
  rx: "4",
  ry: "4",
  width: "170",
  height: "18"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "70",
  rx: "4",
  ry: "4",
  width: "180",
  height: "24"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_content_loader = _resolveComponent("content-loader")!

  return (_openBlock(), _createBlock(_component_content_loader, {
    class: "billing-subscription-method-loader",
    viewBox: "0 0 200 100",
    speed: 1.2,
    primaryColor: "#dad9e3",
    secondaryColor: "#cecdd8"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4
    ]),
    _: 1
  }, 8, ["speed"]))
}